import { FC } from "react";
import { RenderImageProps } from "../types";
import { useFindImages } from "@provider";
import { GatsbyImage } from "gatsby-plugin-image";

const RenderImage: FC<RenderImageProps> = ({ image, name }) => {
  const { findImage } = useFindImages();
  if (!image || !name) {
    return null;
  }

  if (!findImage(image)) {
    return null;
  }

  return <GatsbyImage alt={name} image={findImage(image)} />;
};

export default RenderImage;
